import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { QueryClientProvider } from '@tanstack/react-query';
import {
  ACCESS_TOKEN_KEY,
  CURRENT_NETWORK_KEY,
  keycloak,
  keycloakInitOptions,
  RequireGodLike,
} from '@core/auth';
import { initializeAxiosInterceptors, queryClient } from '@core/http';
import App from './App';
import './index.css';

// Register the interceptors once, before anything can issue a request.
initializeAxiosInterceptors();

/**
 * Keep localStorage in sync with the current token. The axios interceptors read from there on
 * every request, so a silent refresh propagates without re-wiring anything.
 * Ported from viana-journeys-portal-26/src/main.tsx.
 */
function onTokens({ token }: { token?: string }) {
  if (!token) return;
  localStorage.setItem(ACCESS_TOKEN_KEY, token);

  if (localStorage.getItem(CURRENT_NETWORK_KEY)) return;
  const claims = keycloak.tokenParsed as { networks?: string[] } | undefined;
  const defaultNetwork = claims?.networks?.[0];
  if (defaultNetwork) localStorage.setItem(CURRENT_NETWORK_KEY, defaultNetwork);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakInitOptions}
      onTokens={onTokens}
    >
      <QueryClientProvider client={queryClient}>
        <RequireGodLike>
          <App />
        </RequireGodLike>
      </QueryClientProvider>
    </ReactKeycloakProvider>
  </StrictMode>,
);
